/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
  var ageVerifyPopup = $('[data-section-type="magnific-popup"]');
  if(ageVerifyPopup.length) {

    var reappearTime = +(ageVerifyPopup.attr('data-reappear-time'));
    var popup_appear_delay =  +(ageVerifyPopup.attr('data-popup_appear_delay'));

    console.log(popup_appear_delay);

    
    function createCookie(reappearTime){
      if (reappearTime != 0){
        Cookies.set('magnific-popup_delay', 'value', { expires: reappearTime });
      }
    };
    function showModal(){
      
      
      setTimeout(function () {
        $.magnificPopup.open({
          items: {
            src: '.ageVerifyPopup'
          },
          closeOnBgClick: false,
          type: 'inline'
        });
      },popup_appear_delay);

    }

    if (Cookies.get('magnific-popup_delay') === undefined || reappearTime == 0){
      showModal();
      createCookie(reappearTime);
    }

    $('body').on('click','.ageVerifyPopup .btn_enter', function(e) {
      e.preventDefault(); 
      $.magnificPopup.close();
    });
    
    $('body').on('click','.ageVerifyPopup .btn_exit', function(e) {
      e.preventDefault(); 
	  Cookies.set('magnific-popup_delay', 'value', { expires: 0 });
      window.location.href = e.target.href;
    });
  }
});
